import { cookieNames, stashPlatformConstant } from 'stash/utils/native-bridge';
import { getCookie } from 'stash/utils/cookies';
import { datadogRum } from '@datadog/browser-rum';

/**
 * Checks for mobile viewport or device.
 * @returns {boolean}
 */
export const isMobileWeb = () => {
	const userAgent = navigator.userAgent.toLowerCase();
	const isMobileDevice =
		/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

	const isMobileWidth = window.matchMedia
		? window.matchMedia('(max-width: 768px)').matches
		: window.innerWidth <= 768;

	return isMobileDevice || isMobileWidth;
};

/**
 * Checks for native web view
 * @returns {boolean}
 */
export const isNativeWebview = () => {
	const stashPlatformVal = getCookie(cookieNames.NATIVE_PLATFORM);
	return (
		stashPlatformVal === stashPlatformConstant.ANDROID ||
		stashPlatformVal === stashPlatformConstant.IOS
	);
};

// Function to detect Facebook WebView
export const isFBorIGWebView = () => {
	const userAgent = navigator.userAgent || '';
	const isFBorIG =
		userAgent.indexOf('FBAN') > -1 ||
		userAgent.indexOf('FBAV') > -1 ||
		userAgent.indexOf('Instagram') > -1;
	datadogRum.addAction('web-reg custom user agent', {
		ua: userAgent,
		isFBorIG: isFBorIG,
	});
	return isFBorIG;
};

export const isAndroid = () => {
	return navigator.userAgent.includes('Android');
};

export const isIOS = () => {
	return (
		navigator.userAgent.includes('iPhone') ||
		navigator.userAgent.includes('iPad') ||
		navigator.userAgent.includes('iPod')
	);
};

export const transformURLToOpenInNativeBrowser = (urlWithScheme) => {
	if (isAndroid()) {
		const urlWithoutScheme = urlWithScheme.replace(/^https:\/\//, '');
		return `intent://${urlWithoutScheme}#Intent;scheme=https;S.browser_fallback_url=${encodeURIComponent(
			urlWithScheme
		)};end`;
	}

	if (isIOS()) {
		return `x-safari-${urlWithScheme}`;
	}

	return urlWithScheme;
};
